import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getPerformance } from "firebase/performance";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCBI_GKVaoknlWxh7nf3X9yRw1DjRg43V4",
  authDomain: "wedding-ledger-5a449.firebaseapp.com",
  projectId: "wedding-ledger-5a449",
  storageBucket: "wedding-ledger-5a449.firebasestorage.app",
  messagingSenderId: "608942926468",
  appId: "1:608942926468:web:ceef425b30e155692270d1"
};
// Initialize Firebase

const app = initializeApp(firebaseConfig);



// Initialize Firestore
const projectFirestore = getFirestore(app);


// Initialize Auth
const projectAuth = getAuth(app);

// Initialize Performance Monitoring and get a reference to the service
const performance = getPerformance(app);


// Initialize Storage
const projectStorage = getStorage(app);

// Initialize Functions

const functions = getFunctions(app, "asia-southeast1");

// Connect to functions emulator if running locally
// if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
//   connectFunctionsEmulator(functions, '127.0.0.1', 5002);
// }




export { projectFirestore, performance, functions, projectAuth, onAuthStateChanged, projectStorage };
